import React from 'react';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IField {
	value: Nullable<string>;
	label: string;
}

const Field: React.FC<IField> = ({ value, label }) => {
	return <FullInfoField label={label} value={value} />;
};

export default Field;
